import { Button, Card, Grid, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import React from "react";
import PTSFile from '../../../../../../../data/model/common/PTSFile';
import PTSFileLink from '../../../../../../common/component/PTSFileLink';
import SynthesisDesign from "../../../../../../../data/model/design/taskDatas/synthesisDesign/SynthesisDesign";

interface Props {
    data?: SynthesisDesign;
    isLoaded?: boolean;
}

const DesignDownloadFileConatiner: React.FC<Props> = props => {
    const data = props.data;
    const loaded = props.isLoaded || false;

    return (
        <React.Fragment>
            {
                loaded && data &&
                <Card style={{ marginBottom: 15 }}>
                    <Typography style={{ background: 'rgb(212, 239, 223)', padding: 5, paddingLeft: 15, fontSize: '0.875rem' }}>
                        BI 디자인
                    </Typography>
                    <Grid item xl lg sm md>
                        <Button disabled={data.tempTargetBedFile && Object.keys(data.tempTargetBedFile).length <= 1} style={{ padding: 0, margin: 8 }}>
                            <PTSFileLink
                                fileID={(data.tempTargetBedFile as PTSFile).file_id}
                                fileName='Temporary target bed file'
                                mode='text' >
                            </PTSFileLink>
                            <PTSFileLink
                                fileID={(data.tempTargetBedFile as PTSFile).file_id}
                                mode='icon' >
                            </PTSFileLink>
                        </Button>
                        <Button disabled={data.designReport && Object.keys(data.designReport).length <= 1} style={{ padding: 0, margin: 8 }}>
                            <PTSFileLink
                                fileID={(data.designReport as PTSFile).file_id}
                                fileName='Design Report'
                                mode='text' >
                            </PTSFileLink>
                            <PTSFileLink
                                fileID={(data.designReport as PTSFile).file_id}
                                mode='icon' >
                            </PTSFileLink>
                        </Button>
                        <Button disabled={data.homologRegionFile && Object.keys(data.homologRegionFile).length <= 1} style={{ padding: 0, margin: 8 }}>
                            <PTSFileLink
                                fileID={(data.homologRegionFile as PTSFile).file_id}
                                fileName='Homolog Region file'
                                mode='text' >
                            </PTSFileLink>
                            < PTSFileLink
                                fileID={(data.homologRegionFile as PTSFile).file_id}
                                mode='icon' >
                            </PTSFileLink>
                        </Button>
                    </Grid >
                </Card>
            }
        </React.Fragment >
    )
}

export default observer(DesignDownloadFileConatiner);